"use strict";
/*
 * Created on 13.11.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var ProfitLiftSegmentationEnum_1 = require("./ProfitLiftSegmentationEnum");

var SalesLiftSegmentationEnum_1 = require("./SalesLiftSegmentationEnum");

var SegmentationItemEnum_1 = require("./SegmentationItemEnum");
/**
 * Entity for segmentation model item, it defines 9 possible groups from promo clustering.
 *
 * @author ZSr
 *
 * @param salesLift
 * @param profitLift
 * @param value
 */


var SegmentationModelItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SegmentationModelItem, _DomainObject_1$Domai);

  function SegmentationModelItem(salesLift, profitLift, value) {
    var _this;

    _classCallCheck(this, SegmentationModelItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SegmentationModelItem).call(this));
    _this.salesLift = salesLift;
    _this.profitLift = profitLift;
    _this.value = value;
    return _this;
  }

  return SegmentationModelItem;
}(DomainObject_1.DomainObject);

exports.SegmentationModelItem = SegmentationModelItem;

SegmentationModelItem.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder();
  return {
    salesLift: builder.senum('salesLift', SalesLiftSegmentationEnum_1.SalesLiftSegmentationEnum, CodebookLookupSequence_1.CodebookLookupSequence.SegmentationSalesLift),
    profitLift: builder.senum('profitLift', ProfitLiftSegmentationEnum_1.ProfitLiftSegmentationEnum, CodebookLookupSequence_1.CodebookLookupSequence.SegmentationProfitLift),
    value: builder.senum('value', SegmentationItemEnum_1.SegmentationItemEnum, CodebookLookupSequence_1.CodebookLookupSequence.SegmentationItem)
  };
}();